import type { JanusCallRefs } from './sessionRefs';
import { logJanus } from './utils';

function isLiveCall(r: JanusCallRefs): boolean {
  return r.isJoinedRef.current || r.callStatusRef.current === 'oncall';
}

export function createBindMicTrackLifecycle(r: JanusCallRefs): (track: MediaStreamTrack) => void {
  return (track: MediaStreamTrack) => {
    track.onended = () => {
      const current = r.localStreamRef.current?.getAudioTracks()[0];
      if (current !== track) return;

      if (r.micDisconnectHandledRef.current) return;
      if (!isLiveCall(r)) return;

      const networkDrop =
        r.networkDropPendingRef.current ||
        (typeof navigator !== 'undefined' && !navigator.onLine);

      if (networkDrop) {
        r.pendingLocalStreamRefreshRef.current = true;
        logJanus('MIC', 'track ended during network drop — schedule reconnect');
        r.wsReconnectAttemptsRef.current = 0;
        r.scheduleWebSocketReconnectRef.current(true);
        return;
      }

      r.micDisconnectHandledRef.current = true;
      logJanus('MIC', 'track ended (unplugged / permission) — UI warn only');
      r.onAudioHardwareLostRef.current?.({ target: 'mic', reason: 'unplugged' });
    };
  };
}
